import { Reducer } from "redux";

import { NotificationUpdateResponse } from "../models/api/Admin";
import { NotificationUpdateDispatchTypes } from "../models/dispatchTypes/User";
import { NotificationUpdateActionDispatchTypes } from "../constants/User";

const initialState: NotificationUpdateResponse = {
  loading: false,
  response: null,
  error: null,
};

const PutNotificationReducer: Reducer<
NotificationUpdateResponse,
NotificationUpdateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PutNotificationReducer;
